/**
 * Piropa: al agregar (o actualizar) el carrito, muestra un piropo del banco
 * de Marketing (settings.pi_banco_piropos) en el toast/drawer. Se apoya en el
 * pubsub de Dawn (constants.js + pubsub.js, cargados antes que este archivo).
 */
(function () {
  var FALLBACK_PIROPOS = ['Buena elección, reina 💅'];

  function getPiropos() {
    var dataEl = document.getElementById('piropa-piropos-data');
    if (!dataEl) return FALLBACK_PIROPOS;

    var raw;
    try {
      raw = JSON.parse(dataEl.textContent);
    } catch (e) {
      return FALLBACK_PIROPOS;
    }
    if (typeof raw !== 'string') return FALLBACK_PIROPOS;

    var list = null;
    try {
      var parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) list = parsed;
    } catch (e) {
      list = null;
    }
    if (!list) list = raw.split(/\r?\n/);

    list = list.map(function (piropo) {
      return String(piropo || '').trim();
    }).filter(Boolean);

    return list.length ? list : FALLBACK_PIROPOS;
  }

  function pickPiropo() {
    var piropos = getPiropos();
    return piropos[Math.floor(Math.random() * piropos.length)];
  }

  function showPiropo() {
    var targets = document.querySelectorAll('[data-piropa-toast-piropo]');
    targets.forEach(function (el) {
      el.textContent = pickPiropo();
    });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, showPiropo);
  }
})();
